<modal
  [id]="modalId"
  [header]="isEditing() ? 'v2.eventApps.snoball.editConfiguration' : 'v2.eventApps.snoball.addConfiguration'"
  [headerIcon]="headerIcon()"
  [closeButtonEnabled]="!isSaving()"
  [enableBackdropClose]="!isSaving()"
  [escapeToClose]="!isSaving()"
  [widthClass]="'tw-w-[calc(100%-2rem)] tw-max-w-[560px] lg:tw-w-[560px]'"
  [heightClass]="'tw-h-auto tw-max-h-[90vh]'"
  [showFooterDivider]="true"
  (onCloseModal)="onDismiss()"
>
  <div slot="body">
    <div class="tw-flex tw-flex-col tw-gap-4 tw-py-2 tw-font-inter">
      <select-input
        class="tw-w-full"
        [control]="personaIds()"
        [label]="'v2.eventApps.snoball.personas' | translate"
        [placeholder]="'v2.eventApps.snoball.personasPlaceholder' | translate"
        key="name"
        [valueName]="'id'"
        [values]="availablePersonas()"
        [minSelections]="1"
        [maxSelections]="personaMaxSelections()"
        [isDropdown]="true"
        [basicSelect]="true"
        [enableSearch]="true"
        [isSingleSelect]="false"
        [clear]="true"
        [id]="'snoball-personas'"
        [required]="true"
      ></select-input>
      <basic-input
        [control]="projectId()"
        [label]="'v2.eventApps.snoball.projectId' | translate"
        [placeholder]="'v2.eventApps.snoball.projectIdPlaceholder' | translate"
        [required]="true"
        [allowClearButton]="false"
      ></basic-input>
      <basic-input
        [control]="campaignId()"
        [label]="'v2.eventApps.snoball.campaignId' | translate"
        [placeholder]="'v2.eventApps.snoball.campaignIdPlaceholder' | translate"
        [required]="true"
        [allowClearButton]="false"
      ></basic-input>
    </div>
  </div>

  <div slot="footer" class="tw-w-full tw-px-6 tw-pb-6">
    <button
      type="button"
      class="tw-h-12 tw-w-full tw-rounded-lg tw-bg-blue-600 tw-font-inter tw-text-base tw-font-medium tw-text-white hover:tw-bg-blue-700 disabled:tw-bg-blue-300"
      [disabled]="form().invalid || isSaving()"
      [buttonSpinner]="isSaving()"
      (click)="onSave()"
    >
      {{ (isEditing() ? 'v2.common.save' : 'v2.eventApps.snoball.saveAndLink') | translate }}
    </button>
  </div>
</modal>
